window.QuoteScroller ||= class extends HTMLElement {
  constructor() {
    super();

    this.transporter = this.querySelector(".quote-scroller-transporter");
    this.originalQuote = this.transporter.querySelector("div");
    this.walkedSteps = 0;

    this.intersectionObserver = new IntersectionObserver(
      this.onIntersect.bind(this)
    );
    this.intersectionObserver.observe(this);

    this.quoteIntersectionObserver = new IntersectionObserver(
      this.onQuoteIntersect.bind(this),
      { threshold: 0.5 }
    );
    this.quoteIntersectionObserver.observe(this.originalQuote);
  }

  onIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.start();
      } else {
        this.stop();
      }
    })
  }

  onQuoteIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.cloneQuote();
      }
    });
  }

  cloneQuote() {
    let clonedQuote = this.originalQuote.cloneNode(true);

    this.transporter.appendChild(clonedQuote);
    this.quoteIntersectionObserver.observe(clonedQuote);
  }

  reuseQuote(element) {
    this.transporter.appendChild(element);
  }

  animate() {
    this.walkedSteps -= 1;
    this.transporter.style.setProperty("--walked", this.walkedSteps + "px");

    this.start();
  }

  start() {
    this.animation = requestAnimationFrame((timestamp) => {
      this.animate();
    });
  }

  stop() {
    cancelAnimationFrame(this.animation);
  }
}

if (customElements.get("quote-scroller") === undefined) {
  customElements.define("quote-scroller", QuoteScroller);
}